import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-88">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-darker to-brand-dark -z-10" data-id="element-89" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-90">
        <FadeIn data-id="element-91">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6" data-id="element-92">
            Libérate del Apego Emocional en 21 Días:
            <br className="hidden md:block" data-id="element-93" />
            <span className="text-brand-amber" data-id="element-94">
              {' '}
              El Protocolo de Recableado Dopamínico.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-95">
          <h2 className="text-xl md:text-2xl font-serif italic text-brand-amber/90 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-96">
            Detén la obsesión mental, recupera tu sueño y deja de revisar tu
            teléfono cada 5 minutos esperando un mensaje que no llega.
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-97">
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative max-w-2xl mx-auto" data-id="element-98">
            <div className="absolute inset-0 bg-brand-amber/20 blur-[100px] rounded-full -z-10" data-id="element-99" />
            <img src="https://cdn.magicpatterns.com/uploads/t1SjNzkpPmcdXmxZDz8ze4/heylloyd-image-1775686215728.png" alt="Protocolo de Recableado Dopamínico" className="w-full h-auto rounded-xl shadow-2xl shadow-black/50 border border-white/5" data-id="element-100" />
          </motion.div>
        </FadeIn>
      </div>
    </section>;
}